import { createCtx } from './index';
import { getAuthValueFromToken } from '../utils/tokenHelper';

export const defaultAuthValue = {
  isLoggedIn: false,
  isValid: false,
  token: '',
  userName: '',
  userId: '',
  role: '',
  locale: '',
  farmId: '',
  farmNumber: '',
  farmName: '',
  farmType: 0,
  farmMetadata: null as {
    temperatureUnit?: number;
    weightUnit?: number;
  } | null,
  farmTimeZoneId: '',
  vetId: '',
  vetNumber: '',
  businessUnits: [],
  selectedBusinessUnitId: '',
  culture: ''
};

export const getDefaultAuthValue = () => {
  const token = window.localStorage.getItem('token');

  if (!token) {
    return defaultAuthValue;
  }

  const authValue = getAuthValueFromToken(token);

  // Load farm metadata from localStorage
  const farmMetadataStr = window.localStorage.getItem('farmMetadata');
  if (farmMetadataStr) {
    try {
      authValue.farmMetadata = JSON.parse(farmMetadataStr);
    } catch (e) {
      console.error('Failed to parse farmMetadata from localStorage:', e);
    }
  }

  authValue.farmTimeZoneId = window.localStorage.getItem('farmTimeZoneId') ?? '';

  return authValue;
};

export const [ctx, provider] = createCtx(getDefaultAuthValue());
// Local re-export under the names the rest of the app imports. This used to be written as
// `export { ... } from './AuthContext'` - a module re-exporting from itself.
export { ctx as AuthContext, provider as AuthProvider };
